/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Logo from './Logo';
import CopyToClipboard from './CopyToClipboard';

export default function Credentials({ newCluster, resetCredentials }) {
  const { 'ag-username': username, 'ag-password': password } = newCluster || {};
  const [checkboxState, setCheckboxState] = React.useState(false);
  const open = Boolean(password);

  const handleEntering = () => {};
  return (
    <Dialog
      maxWidth="sm"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
    >
      <DialogTitle>Save Credentials for AllegroGraph WebView</DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <Typography variant="body1">
          Below is the authentication UI in AllegroGraph WebView where you type
          the following credentials.
        </Typography>
        <Container
          disableGutters
          maxWidth={false}
          sx={{ height: '100%', width: '100%', backgroundColor: '#80808030' }}
        >
          <Container
            maxWidth="xs"
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Paper elevation={4} sx={{ p: 4, m: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Logo />
                <Typography component="h1" variant="h5" sx={{ pt: 4 }}>
                  WebView authorization
                </Typography>
                <Box sx={{ mt: 1 }}>
                  <FormControl color="webviewPrimary" fullWidth margin="normal">
                    <InputLabel htmlFor="username">Username</InputLabel>
                    <OutlinedInput
                      id="username"
                      type="text"
                      value={username}
                      endAdornment={
                        <InputAdornment position="end">
                          <CopyToClipboard value={username} />
                        </InputAdornment>
                      }
                      label="Username"
                    />
                  </FormControl>
                  <FormControl color="webviewPrimary" fullWidth margin="normal">
                    <InputLabel htmlFor="password">Password</InputLabel>
                    <OutlinedInput
                      id="password"
                      type="text"
                      value={password}
                      endAdornment={
                        <InputAdornment position="end">
                          <CopyToClipboard value={password} />
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  </FormControl>
                </Box>
              </Box>
            </Paper>
          </Container>
        </Container>
        <Divider />
        <Box sx={{ pt: 2 }}>
          <Typography variant="subtitle2">
            These credentials are only showed once. Save them in a secure place.
            You will need them to log in to the AllegroGraph server. You'll be
            able to change password and add more users for this server later.
          </Typography>
          <FormControlLabel
            sx={{ pt: 1 }}
            control={
              <Checkbox
                data-cy="saved-credentials-checkbox"
                onChange={(e) => {
                  setCheckboxState(e.target.checked);
                }}
                checked={checkboxState}
                autoFocus
              />
            }
            label="I have saved credentials"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          data-cy="saved-credentials-button"
          disabled={!checkboxState}
          onClick={() => {
            setCheckboxState(false);
            resetCredentials();
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
